import {
  addDoc,
  collection,
  getDocs,
  getFirestore,
  serverTimestamp,
} from '@firebase/firestore';
import React, { useState, useEffect } from 'react';
import { useSpring, animated } from 'react-spring';
import { toast } from 'react-toastify';
import Backbutton from '../../global/Backbutton';
import MultiSelectInput from '../../global/MultiSelectInput';

import CheckMark from '../../../assets/checkmark.svg';
import UnChecked from '../../../assets/radio-unchecked.svg';
import Checked from '../../../assets/radio-checked.svg';

const AddNewsflashPopup = ({ setShowingSelf }) => {
  const [preTitle, setPreTitle] = useState('');
  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState('');
  const [content, setContent] = useState('');
  const [link, setLink] = useState('');
  const [organizations, setOrganizations] = useState([]);
  const [organizationRows, setOrganizationRows] = useState([]);
  const [allOrganizations, setAllOrganizations] = useState([]);

  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    const db = getFirestore();
    getDocs(collection(db, 'organizations'))
      .then((snapshot) => {
        setAllOrganizations((_) => {
          return snapshot.docs.map((e) => {
            return e.data();
          });
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  useEffect(() => {
    setOrganizationRows((_) => {
      return allOrganizations.map((e) => {
        return {
          label: e.name,
          value: e.id,
        };
      });
    });
    setOrganizations((_) => {
      return allOrganizations.map((e) => {
        return e.id;
      });
    });
  }, [allOrganizations]);

  const [isCreatingNewsflash, setIsCreatingNewsflash] = useState(false);
  const submit = () => {
    if (isCreatingNewsflash) return;
    var valid = true;
    if (!title) {
      valid = false;
      toast.error('Ange en titel');
    }
    if (!organizations.length) {
      valid = false;
      toast.error('Välj minst en organisation');
    }
    if (!valid) return;
    setIsCreatingNewsflash(true);

    const documentData = {
        preTitle: preTitle,
        title: title,
        subTitle: subTitle,
        content: content,
        link: link,
        organizations: organizations,
        published: isPublished,
    }

    if (isPublished) {
        documentData["timeCreated"] = serverTimestamp()
    }

    const db = getFirestore();
    const promise = addDoc(collection(db, 'newsflashes'), documentData)
      .then(() => {
        setIsCreatingNewsflash(false);
        setShowingSelf(false);
      })
      .catch((err) => {
        console.error(err);
        setIsCreatingNewsflash(false);
      });

    toast.promise(promise, {
      pending: 'Skapar newsflash... Vänligen lämna inte sidan',
      error: 'Någonting gick fel! Vänligen försök igen senare.',
      success: 'Newsflash skapad utan problem!',
    });
  };

  const springprops = useSpring({
    to: { opacity: 1, x: 0, maxWidth: '100%', maxHeight: '100%' },
    from: { opacity: 0, x: 16, maxWidth: '100%', maxHeight: '100%' },
    config: { friction: 20, tension: 400 },
  });

  return (
    <div className="modal blur">
      <animated.div style={springprops}>
        <div className="card medium">
          <Backbutton
            normal={'Stäng'}
            target={'Hantera Newsflash'}
            onClick={() => {
              setShowingSelf(false);
            }}
          />
          <form>
            <label>Förtitel</label>
            <input
              type="text"
              placeholder="T.ex. 'NYHET!'"
              value={preTitle}
              onChange={(e) => setPreTitle(e.target.value)}
            />
            <label className="required">Titel</label>
            <input
              type="text"
              placeholder="Titel"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <label>Undertitel</label>
            <input
              type="text"
              placeholder="T.ex. 'Läs mer på bloggen'"
              value={subTitle}
              onChange={(e) => setSubTitle(e.target.value)}
            />
            <label>Innehåll</label>
            <textarea
              placeholder="Längre innehåll"
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
            <label>Länk</label>
            <input
              type="text"
              placeholder="Länk"
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
            <label className="required">Organisationer</label>
            <MultiSelectInput
              rows={organizationRows}
              state={organizations}
              setState={setOrganizations}
              hasSelectAll={true}
            />
            <label>Status</label>
            <div className="checkboxgroup">
              <div
                className="checkboxrow"
                onClick={() => setIsPublished((p) => !p)}
              >
                <img
                  src={isPublished ? Checked : UnChecked}
                  className="doinvert radio"
                  alt=""
                />
                <p>Publicerad</p>
              </div>
            </div>
            <div></div>
            <button onClick={submit} type="button">
              <img src={CheckMark} className="doinvert" alt="" />
              Skapa Newsflash
            </button>
          </form>
        </div>
      </animated.div>
    </div>
  );
};

export default AddNewsflashPopup;
